<template>
  <path
    fill="none"
    stroke="currentColor"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width="1"
    d="M1 1C1 1 3 2.5 3 6C3 9.5 1 11 1 11"
  />
</template>
